import React from 'react';

import Container from 'components/Container';

import EntitiesPropTypes from 'utils/propTypes/entities';

import styles from './styles.module.scss';

const BroadcastInformation = ({ broadcast }) => {
	const { organizationName, institute } = broadcast;

	const broadcastOrganizationName =
		organizationName || institute?.passport?.organization || institute?.title;

	return (
		<Container width="narrow">
			<div className={styles.line} />
			<div className={styles.disclaimer}>
				<p>
					{broadcastOrganizationName && (
						<>
							Информация предоставлена организацией {broadcastOrganizationName}.{' '}
						</>
					)}
					Администрация портала &laquo;
					<a href="/">Культура.РФ</a>&raquo; не несет ответственности за
					достоверность представленных сведений, а также за действия
					Организатора и/или иных лиц, действующих от его имени и по его
					поручению либо от своего имени, но по поручению Организатора, а равно
					за организацию, проведение и содержание онлайн трансляции.
				</p>
			</div>
		</Container>
	);
};

BroadcastInformation.propTypes = {
	broadcast: EntitiesPropTypes.broadcastItem.isRequired
};

export default BroadcastInformation;
